import { Link } from "gatsby";
import React from "react";
import { useState } from "react";
import { slide as Menu } from "react-burger-menu";
import * as s from "./mobile-menu.module.css";
import DemoButton from './../../demoButton/demoButton';

var styles = {
  bmBurgerButton: {
    position: "absolute",
    width: "30px",
    height: "24px",
    right: "36px",
    top: "28px",
  },
  bmBurgerBars: {
    background: "#000",
    height: "3px",
  },
  bmBurgerBarsHover: {
    background: "#ffffff",
  },
  bmCrossButton: {
    top: "20px",
    right: "20px",
    height: "28px",
    width: "28px",
  },
  bmCross: {
    height: "28px",
    background: "#000",
  },
  bmMenuWrap: {
    position: "fixed",
    top: "0",
    height: "100%",
  },
  bmMenu: {
    background: "#FFECDE",
    padding: "60px 18px 0px 18px",
    // fontSize: '1.15em'
  },
  bmMorphShape: {
    fill: "#373a47",
  },
  bmItemList: {
    color: "#b8b7ad",
    padding: "0.8em",
  },
  bmItem: {
    display: "flex",
    flexDirection: "columns",
    color: "#fff",
  },
  bmOverlay: {
    top: "0",
    background: "rgba(0, 0, 0, 0.3)",
  },
};

const MobileNav = ({ menuItems }) => {
  const [opened, setOpened] = useState([]);

  const toggleSubMenu = i => {
    let newOpened;
    if (isOpened(i)) {
      newOpened = opened.filter(o => o !== i);
    } else {
      newOpened = [...opened, i];
    }
    // console.log(newOpened);
    setOpened(newOpened);
  };

  const isOpened = i => {
    return opened.some(o => o === i);
  };

  return (
    <Menu className="mobileNav" right styles={styles}>
      <div className={`d-flex flex-column pb-4`}>
        <div className="header-cta-outline position-relative">
          <Link to={'https://demo.orders.co?s=w'} target="_blank" className="header-cta w-100">Website Builder</Link>
          <div className="blue-badge position-absolute" style={{ top: '-6px', right: '-4px' }}>
            <span style={{ fontSize: '12px' }}>AI</span> powered
          </div>
        </div>
        <DemoButton scrollToForm={"#"} classes={["mt-1", "mb-2"]}>Schedule a DEMO</DemoButton>
        {menuItems.map((mi, i) => {
          let hasSubMenu = !!mi.items && mi.items.length > 0;
          return (
            <div
              key={`header-menu-item-${i}`}
              className={`${isOpened(i) ? s.opened : ""} ${s.menuItem} ${hasSubMenu ? s.hasSubmenu : ""
                } mb-3`}
            >
              {hasSubMenu && (
                <>
                  <span
                    onClick={() => {
                      toggleSubMenu(i);
                    }}
                  >
                    {mi.label}
                  </span>
                  <div className={`${s.subMenu}`}>
                    {mi.items.map((smi, j) => (
                      <div
                        key={`header-submenu-item-${i}-${j}`}
                        className={`${s.menuItem}`}
                      >
                        {!!smi.uri && <Link to={smi.uri}>{smi.label}</Link>}
                        {!smi.uri && <span>{smi.label}</span>}
                      </div>
                    ))}
                  </div>
                </>
              )}
              {!hasSubMenu && !!mi.uri && (
                <>
                  {!!mi.target && mi.target === "_blank" && (
                    <a href={mi.uri} rel="noreferrer" target="_blank">
                      {mi.label}
                    </a>
                  )}
                  {!mi.target && <Link to={mi.uri}>{mi.label}</Link>}
                </>
              )}
            </div>
          );
        })}
      </div>
    </Menu>
  );
};

export default MobileNav;
